import script from "./TagEtaPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TagEtaPopup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__